import { StageDef } from '../automationMachineInterfaces'
import { TWITTER_AUTOMATION_STAGE_STATUSES } from './twitterAutomationStageStatuses'
import * as twitterUrls from './twitterUrls'
import { XSettingKey } from '../../recommendations/recommendationSettingsKeys'
import * as enums from '../../utils/enums'
import { getWaitForElementToAppearPromise } from '../interruptiblePromises'
import { evaluateXpath } from '../interruptibleXpath'
import {
  defaultCantUndoFn,
  defaultIsDisabledFn,
  defaultIsDisabledReasonFn,
  getCurrentValueFnFromKey,
  getIsFulfilledFnFromKey,
} from '../recommendationCardDisplayUtils'

// Settings property functions
const getCurrentValueFn = (key) =>
  getCurrentValueFnFromKey(key, (value) => (value ? 'On' : 'Off'))

const getIsFulfilledFn = (key) => getIsFulfilledFnFromKey(key, (value) => value)

const getCantUndoFn = () => defaultCantUndoFn
const getIsDisabledFn = () => defaultIsDisabledFn
const getIsDisabledReasonFn = () => defaultIsDisabledReasonFn

enum StageKey {
  GATHER_SETTING_LOGIN_VERIFICATION = 'GATHER_SETTING_LOGIN_VERIFICATION',
}

async function atLeastOneLoginVerificationMethodChecked() {
  await getWaitForElementToAppearPromise(
    document,
    () =>
      evaluateXpath<HTMLElement>(
        document,
        `//input[@type="checkbox" and @aria-describedby]`,
      )[0],
  )

  const inputCheckBoxes = evaluateXpath<HTMLInputElement>(
    document,
    '//input[@type="checkbox" and @aria-describedby]',
  )

  return inputCheckBoxes.some((checkbox) => checkbox.checked)
}

const gatherStageDefs: StageDef[] = [
  {
    type: enums.StageType.ACTION,
    key: StageKey.GATHER_SETTING_LOGIN_VERIFICATION,
    status: TWITTER_AUTOMATION_STAGE_STATUSES.GATHERING_SETTINGS,
    url: twitterUrls.twoFaSettingsUrl,
    action: async (machineContext, userContext) => {
      const { updateStoredInitialValues } = userContext

      const loginVerificationSetting =
        await atLeastOneLoginVerificationMethodChecked()

      await updateStoredInitialValues(
        { [XSettingKey.LOGIN_VERIFICATION]: loginVerificationSetting },
        enums.TwitterRecommendationKey.TWITTER_2FA,
      )
    },
  },
]

const updateStageDefs: StageDef[] = []
const undoStageDefs: StageDef[] = []

export {
  getCantUndoFn,
  getCurrentValueFn,
  getIsDisabledFn,
  getIsDisabledReasonFn,
  getIsFulfilledFn,
  gatherStageDefs,
  updateStageDefs,
  undoStageDefs,
}
